import React from 'react';
import { Container, Typography, Box, Paper, ThemeProvider } from '@mui/material';
import NavBar from '../../layout/NavBar';
import NavBarBot from '../../layout/NavBarBot';
import { darkTheme } from '../../../theme/darkTheme';
import ImpressumAbschnitt from './components/impressum/ImpressumAbschnitt';

const Impressum = () => {
    return (
        <ThemeProvider theme={darkTheme}>
            <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', pb: 8 }}>
                <NavBar />
                <Container maxWidth="md" sx={{ mt: 4 }}>
                    <Paper
                        elevation={3}
                        sx={{
                            p: { xs: 3, md: 5 },
                            borderRadius: '16px',
                            bgcolor: 'background.paper',
                            border: '1px solid rgba(59, 130, 246, 0.2)'
                        }}
                    >
                        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: 'primary.main', mb: 4 }}>
                            Impressum
                        </Typography>

                        <ImpressumAbschnitt title="Angaben gemäß § 5 TMG">
                            Philipp Feld<br />
                            Mainstraße 7<br />
                            49809 Lingen
                        </ImpressumAbschnitt>

                        <ImpressumAbschnitt title="Kontakt" withDivider>
                            Telefon: 01713482859<br />
                            E-Mail: philipp.feld@web.de
                        </ImpressumAbschnitt>

                        <ImpressumAbschnitt title="Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV" withDivider>
                            Philipp Feld<br />
                            Mainstraße 7<br />
                            49809 Lingen
                        </ImpressumAbschnitt>

                        <ImpressumAbschnitt title="Streitschlichtung" withDivider>
                            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
                            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6', marginLeft: '5px' }}>
                                https://ec.europa.eu/consumers/odr
                            </a>.<br />
                            Unsere E-Mail-Adresse finden Sie oben im Impressum.<br /><br />
                            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                        </ImpressumAbschnitt>
                    </Paper>
                </Container>
            </Box>
            <NavBarBot />
        </ThemeProvider>
    );
};

export default Impressum;
